// removed by extract-text-webpack-plugin
module.exports = {"StoreNotAvailableTitle":"StoreNotAvailable__StoreNotAvailableTitle__37zjF","StoreNotAvailableText":"StoreNotAvailable__StoreNotAvailableText__1mRip","StoreNotAvailableButtonContainer":"StoreNotAvailable__StoreNotAvailableButtonContainer__LZAME","AvailabilityTitle":"StoreNotAvailable__AvailabilityTitle__1Fgqx","AvailabilityMessage":"StoreNotAvailable__AvailabilityMessage__1MjjQ","PhoneLink":"StoreNotAvailable__PhoneLink__3MFMW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TimePicker/StoreNotAvailable.css
// module id = 69
// module chunks = 0